const tutorFlow = [
  /*** Step 0 ***/
  ["Home"],

  /*** Step 1 ***/
  [],

  /*** Step 2 ***/
  [],

  /*** Step 3 ***/
  [],

  /*** Step 4 ***/
  [],

  /*** Step 5 ***/
  [
    "TutorSetType",
    "TutorCardDocumentation",
    "TutorRequestCertificate",
    "TutorCardSign",
    "TutorInfocertSign",
    "TutorConfirmAccessCode",
    "TutorConfirmMobileToken"
  ],

  /*** Step 6 ***/
  ["TutorRegistrationCompleted"],

  /*** Step 7 ***/
  ["TutorRegistrationCompleted"],

  /*** Step 8 ***/
  ["TutorRegistrationCompleted"],

  /** Step 9 */
  ["TutorRegistrationCompleted"]
];

export default tutorFlow;
